/**
 * @class nameValueLib
 * @brief This library is used to facilitate arrays of name/value pair objects.
 * @details This library has utility function for an
 *			object with  name/value properties. The
 *			utility functions are able to utilize nested arrays
 *           of these name/value pair objects.
 * @version 0.1
 * @date 07/15/2014
 */

//Global Variables.
var g_nameProp = 'name';
var g_aliasProp = 'alias';
var g_valueProp = 'value';
var g_typeProp = 'type';

var nameValueLib = (function () {
  return {
    /**
     * @fn 		objectExists
     * @brief 	Function to check whether any object in the array has the particular name.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are looking for names in a nested array of objects, pass an array of names.
     * @return 	An integer with the index of the first item matching the name. -1 if no matches were found.
     */
    objectExists: function (arrSource, arrNames) {
      //Declare Important Variables.
      var nFoundIndex = -1;
      var sourceArray = arrSource;

      for (var nameIndex = 0; nameIndex < arrNames.length; nameIndex++) {
        var curName = arrNames[nameIndex];
        nFoundIndex = -1;
        for (var sourceIndex = 0; sourceIndex < sourceArray.length; sourceIndex++) {
          var objCurrent = sourceArray[sourceIndex];

          if (objCurrent[g_nameProp] == curName) {
            //Get the index.
            nFoundIndex = sourceIndex;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (nFoundIndex == -1) {
          break;
        }
      }

      return nFoundIndex;
    },
    /**
     * @fn 		objectExitsEX
     * @brief 	Function to check whether any object in the array has the particular alias.
     * @param 	arrSource: The array to look through for an object with the specified alias
     * @param 	arrNames: An array of aliases. If you are looking for aliases in a nested array of objects, pass an array of aliases.
     * @return 	An integer with the index of the first item matching the alias. -1 if no matches were found.
     */
    objectExistsEX: function (arrSource, arrAliases) {
      //Declare Important Variables.
      var nFoundIndex = -1;
      var sourceArray = arrSource;

      //$.each(arrAliases, function(aliasIndex, curAlias) {
      for (var aliasIndex = 0; aliasIndex < arrAliases.length; aliasIndex++) {
        var curAlias = arrAliases[aliasIndex];
        nFoundIndex = -1;
        // $.each(sourceArray, function(sourceIndex, objCurrent) {
        for (var sourceIndex = 0; sourceIndex < sourceArray.length; sourceIndex++) {
          var objCurrent = sourceArray[sourceIndex];
          if (objCurrent[g_aliasProp] == curAlias) {
            //Get the index.
            nFoundIndex = sourceIndex;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (nFoundIndex == -1) {
          break;
        }
      }

      return nFoundIndex;
    },
    /**
     * @fn 		objectExistsMixed
     * @brief 	Function to check if object exists in the array with the particular name or alias.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNamesAliases: An array of names or alias in the order of nested searching.
     * @param 	arrNameOrAlias: An array of keyword "name" or "alias". Index will be matched to arrNamesAliases for which property to check.
     * @return  An integer with the index of the first item matching the alias. -1 if no matches were found.
     */
    objectExistsMixed: function (arrSource, arrNamesAliases, arrNameOrAlias) {
      //Declare Important Variables.
      var nFoundIndex = -1;
      var sourceArray = arrSource;

      for (var nNameAliasIndex = 0; nNameAliasIndex < arrNamesAliases.length; nNameAliasIndex++) {
        nFoundIndex = -1;
        for (var nSourceIndex = 0; nSourceIndex < sourceArray.length; nSourceIndex++) {
          var objCurrent = sourceArray[nSourceIndex];
          const searchProp = arrNameOrAlias[nNameAliasIndex] || g_nameProp;
          if (objCurrent[searchProp] == arrNamesAliases[nNameAliasIndex]) {
            //Get the found Object Array.
            nFoundIndex = nSourceIndex;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (nFoundIndex === -1) {
          break;
        }
      }

      return nFoundIndex;
    },

    /**
     * @fn 		getResults
     * @brief 	Asynchronous function to update the characteristic labels with level rank and level name
     * @param 	strCountryCodes: An array consisting of user selected country ids
     * @param 	_arrRawData: An array of user selected indicator and country data
     * @return 	An array containing user selected api data with appropriate level rank
     */
    getResults: async function (strCountryCodes, _arrRawData, strLVLRNK) {
      return new Promise((resolve, reject) => {
        window.loadMapBundle().then(function (mod) {
          const FeatureLayer = mod.FeatureLayer;
          let url = 'https://gis.dhsprogram.com/arcgis/rest/services/Geometry/SDR_Regions/MapServer/0';

          const featureLayer = new FeatureLayer({
            url: url,
          });

          let query = featureLayer.createQuery();

          query.returnGeometry = false;
          query.outFields = ['REG_ID', 'LEVELRNK', 'LEVELNA'];
          query.where = 'DHSCC IN (' + strCountryCodes + ') AND LEVELRNK IN (' + strLVLRNK + ')';

          let allDataRecords = [];

          // Convert string to array of country codes and remove excess qoutation marks."'BD','NP'" => ['BD', 'NP']
          const arrCountryCodes = strCountryCodes.split(',').map((countryCode) => countryCode.slice(1, 3));

          // Delete countries no longer selected from the level names object
          for (let survey in objUniqueLvlNames) {
            for (let countryCode in objUniqueLvlNames[survey]) {
              if (!arrCountryCodes.includes(countryCode)) {
                delete objUniqueLvlNames[survey][countryCode];
              }
            }
          }

          featureLayer.queryFeatures(query).then(function (results) {
            _arrRawData.forEach((dataRecord) => {
              if (
                dataRecord.CharacteristicCategory === Config.getUniversalString('region') &&
                !dataRecord.CharacteristicLabel.includes('(L')
              ) {
                var regionFound = results.features.find((item) => item.attributes.REG_ID === dataRecord.RegionId);

                if (regionFound && regionFound.attributes) {
                  const regionLevelRnk = regionFound.attributes.LEVELRNK; // level rank aka subregion or subnational - 1, 2, or 3
                  const regionLevelNa = regionFound.attributes.LEVELNA; // level name - Regions, Divisions, Provinces, etc.
                  const regionCountryCode = dataRecord.DHS_CountryCode;
                  const surveyId =
                    dataRecord.SurveyYearLabel && dataRecord.SurveyType
                      ? `${dataRecord.SurveyYearLabel} ${dataRecord.SurveyType}`
                      : null; // e.g. 2016 DHS

                  // get regions's Level name value
                  dataRecord.LevelNa = regionLevelNa ? regionLevelNa : '';

                  // appened region's level rank to label, if it exists
                  dataRecord.CharacteristicLabel = regionLevelRnk
                    ? dataRecord.CharacteristicLabel + ' (L' + regionLevelRnk + ')'
                    : dataRecord.CharacteristicLabel;

                  // If all data is available, add to object with level names by level rank, country, and survey
                  // This object is used during dashboard updates to create specific level name labels
                  if (surveyId && regionCountryCode && regionLevelRnk && regionLevelNa) {
                    if (objUniqueLvlNames[surveyId]) {
                      if (objUniqueLvlNames[surveyId][regionCountryCode]) {
                        // Establish new level rank value in existing country
                        if (objUniqueLvlNames[surveyId][regionCountryCode][regionLevelRnk] === undefined) {
                          objUniqueLvlNames[surveyId][regionCountryCode][regionLevelRnk] = regionLevelNa;
                        }
                      }
                      // Establish new country in existing survey
                      else {
                        objUniqueLvlNames[surveyId][regionCountryCode] = {
                          [regionLevelRnk]: regionLevelNa,
                        };
                      }
                    }
                    // Establish new survey object
                    else {
                      objUniqueLvlNames[surveyId] = {
                        [regionCountryCode]: {
                          [regionLevelRnk]: regionLevelNa,
                        },
                      };
                    }
                  }
                }
              }
              allDataRecords.push(dataRecord);
            });

            if (!$('.drawerOpen').is(':visible')) {
              toggleDrawer();
            }
            resolve(allDataRecords);
          });
        });
      });
    },

    /**
     * @fn 		objectExistsPartial
     * @brief 	Function to check whether any object in the array contains the name. Note: This is valid for substring matches.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are looking for names in a nested array of objects, pass an array of names.
     * @return 	An integer with the index of the first item containing the name. -1 if no matches were found.
     */
    objectExistsPartial: function (arrSource, arrNames) {
      //Declare Important Variables.
      var nFoundIndex = -1;
      var sourceArray = arrSource;

      $.each(arrNames, function (nameIndex, curName) {
        nFoundIndex = -1;
        $.each(sourceArray, function (sourceIndex, objCurrent) {
          var patt = new RegExp(curName);
          var res = patt.exec(objCurrent[g_nameProp]);
          if (res != null && typeof res != 'undefined' && res.length) {
            //Get the index.
            nFoundIndex = sourceIndex;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            return false;
          }
        });

        //If you did not find anything, do not continue.
        if (nFoundIndex == -1) {
          return false;
        }
      });

      return nFoundIndex;
    },
    /**
     * @fn 		getAlias
     * @brief 	Function to obtain the alias of an object with the particular name.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are getting a value in a nested array of objects, pass an array of names.
     * @return   The alias of the property with the name provided. null otherwise.
     */
    getAlias: function (arrSource, arrNames) {
      //Declare Important Variables.
      var objNextObject = null;
      var objAlias = '';
      var sourceArray = arrSource;
      var nArrayNamesLength = arrNames.length;

      for (var nNameIndex = 0; nNameIndex < arrNames.length; nNameIndex++) {
        objNextObject = null;
        for (var nSourceIndex = 0; nSourceIndex < sourceArray.length; nSourceIndex++) {
          var objCurrent = sourceArray[nSourceIndex];
          if (objCurrent[g_nameProp] == arrNames[nNameIndex]) {
            //Get the Next Object Array.
            objNextObject = objCurrent[g_valueProp];

            //Set the Alias.
            objAlias = objCurrent[g_aliasProp];

            //Set the Source Array to the Next Object.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (!objNextObject && nNameIndex < nArrayNamesLength - 1) {
          objAlias = null;
          break;
        }
      }

      return objAlias;
    },
    /**
     * @fn 		getValue
     * @brief 	Function to obtain the value of an object with the particular name.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are getting a value in a nested array of objects, pass an array of names.
     * @return   The value of the property with the name provided. null otherwise.
     */
    getValue: function (arrSource, arrNames) {
      //Declare Important Variables.
      var sourceArray = arrSource;
      var nFoundArray = null;

      $.each(arrNames, function (nameIndex, curName) {
        nFoundArray = null;

        $.each(sourceArray, function (sourceIndex, objCurrent) {
          if (objCurrent[g_nameProp] != undefined) {
            if (objCurrent[g_nameProp].toString().toLowerCase() == curName.toString().toLowerCase()) {
              //Get the found Object Array.
              nFoundArray = objCurrent[g_valueProp];

              //Obtain the Object Array.
              sourceArray = objCurrent[g_valueProp];

              //Exit out of the loop.
              return false;
            }
          }
        });

        //If you did not find anything, do not continue.
        if (nFoundArray === null) {
          return false;
        }
      });

      return nFoundArray;
    },
    /**
     * @fn 		getValueMixed
     * @brief 	Function to obtain the value of an object with the particular name or alias.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNamesAliases: An array of names or alias in the order of nested searching.
     * @param 	arrNameOrAlias: An array of keyword "name" or "alias". Index will be matched to arrNamesAliases for which property to check.
     * @return   The value of the property with the name provided. null otherwise.
     */
    getValueMixed: function (arrSource, arrNamesAliases, arrNameOrAlias) {
      //Declare Important Variables.
      var nFoundArray = null;
      var sourceArray = arrSource;

      for (var nNameIndex = 0; nNameIndex < arrNamesAliases.length; nNameIndex++) {
        nFoundArray = null;
        for (var nSourceIndex = 0; nSourceIndex < sourceArray.length; nSourceIndex++) {
          var objCurrent = sourceArray[nSourceIndex];
          const searchProp = arrNameOrAlias[nNameIndex] || g_nameProp;
          if (objCurrent[searchProp] == arrNamesAliases[nNameIndex]) {
            //Get the found Object Array.
            nFoundArray = objCurrent[g_valueProp];

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (!nFoundArray) {
          break;
        }
      }

      //If nothing is found, set return to null.
      if (!nFoundArray) {
        nFoundArray = null;
      }

      return nFoundArray;
    },
    /**
     * @fn 		getValueEX
     * @brief 	Function to obtain the value of an object with the particular alias.
     * @param 	arrSource: The array to look through for an object with the specified alias
     * @param 	arrNames: An array of aliases. If you are getting a value in a nested array of objects, pass an array of aliases.
     * @return   The value of the property with the alias provided. null otherwise.
     */
    getValueEX: function (arrSource, arrAliases) {
      //Declare Important Variables.
      var nFoundArray = null;
      var sourceArray = arrSource;

      $.each(arrAliases, function (aliasIndex, curAlias) {
        nFoundArray = null;
        $.each(sourceArray, function (sourceIndex, objCurrent) {
          if (objCurrent[g_aliasProp] == curAlias) {
            //Get the found Object Array.
            nFoundArray = objCurrent[g_valueProp];

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            return false;
          }
        });

        //If you did not find anything, do not continue.
        if (!nFoundArray) {
          return false;
        }
      });

      return nFoundArray;
    },
    /**
     * @fn 		getValueEmpty
     * @brief 	Function to obtain the value of an object with the particular name.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are getting a value in a nested array of objects, pass an array of names.
     * @return   The value of the property with the name provided. empty string otherwise.
     */
    getValueEmpty: function (arrSource, arrNames) {
      //Declare Important Variables.
      var nFoundArray = null;
      var sourceArray = arrSource;

      for (var nNameIndex = 0; nNameIndex < arrNames.length; nNameIndex++) {
        nFoundArray = null;
        for (var nSourceIndex = 0; nSourceIndex < sourceArray.length; nSourceIndex++) {
          var objCurrent = sourceArray[nSourceIndex];
          if (objCurrent[g_nameProp] == arrNames[nNameIndex]) {
            //Get the found Object Array.
            nFoundArray = objCurrent[g_valueProp];

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (!nFoundArray) {
          break;
        }
      }

      //If nothing is found, set return to empty string.
      if (!nFoundArray) {
        nFoundArray = '';
      }

      return nFoundArray;
    },
    /**
     * @fn 		getValueEmptyMixed
     * @brief 	Function to obtain the value of an object with the particular name or alias.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNamesAliases: An array of names or alias in the order of nested searching.
     * @param 	arrNameOrAlias: An array of keyword "name" or "alias". Index will be matched to arrNamesAliases for which property to check.
     * @return   The value of the property with the name provided. empty string otherwise.
     */
    getValueEmptyMixed: function (arrSource, arrNamesAliases, arrNameOrAlias) {
      //Declare Important Variables.
      var nFoundArray = null;
      var sourceArray = arrSource;

      for (var nNameIndex = 0; nNameIndex < arrNamesAliases.length; nNameIndex++) {
        nFoundArray = null;
        for (var nSourceIndex = 0; nSourceIndex < sourceArray.length; nSourceIndex++) {
          var objCurrent = sourceArray[nSourceIndex];
          const searchProp = arrNameOrAlias[nNameIndex] || g_nameProp;
          if (objCurrent[searchProp] == arrNamesAliases[nNameIndex]) {
            //Get the found Object Array.
            nFoundArray = objCurrent[g_valueProp];

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            break;
          }
        }

        //If you did not find anything, do not continue.
        if (!nFoundArray) {
          break;
        }
      }

      //If nothing is found, set return to empty string.
      if (!nFoundArray) {
        nFoundArray = '';
      }

      return nFoundArray;
    },
    /**
     * @fn 		getObject
     * @brief 	Function to obtain a certain object by name.
     * @param 	arrSource: The array to look through for an object with the specified name
     * @param 	arrNames: An array of names. If you are getting an object in a nested array of objects, pass an array of names.
     * @return   The object of the property with the name provided. null otherwise.
     */
    getObject: function (arrSource, arrNames) {
      //Declare Important Variables.
      var objFound = null;
      var sourceArray = arrSource;

      $.each(arrNames, function (nameIndex, curName) {
        objFound = null;
        $.each(sourceArray, function (sourceIndex, objCurrent) {
          if (objCurrent[g_nameProp] == curName) {
            //Get the found Object Array.
            objFound = objCurrent;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            return false;
          }
        });
      });

      return objFound;
    },
    /**
     * @fn 		getObject
     * @brief 	Function to obtain a certain object by alias.
     * @param 	arrSource: The array to look through for an object with the specified alias
     * @param 	arrNames: An array of aliases. If you are getting an object in a nested array of objects, pass an array of aliases.
     * @return   The object of the property with the alias provided. null otherwise.
     */
    getObjectEX: function (arrSource, arrAlises) {
      //Declare Important Variables.
      var objFound = null;
      var sourceArray = arrSource;

      $.each(arrAlises, function (aliasIndex, curAlias) {
        //	objFound = null;
        $.each(sourceArray, function (sourceIndex, objCurrent) {
          if (objCurrent[g_aliasProp] == curAlias) {
            //Get the found Object Array.
            objFound = objCurrent;

            //Obtain the Object Array.
            sourceArray = objCurrent[g_valueProp];

            //Exit out of the loop.
            return false;
          }
        });
      });

      return objFound;
    },
    createObject: function (name, alias, val, createArrayWrapper) {
      //Create New Object.
      var newObject = {};
      newObject[g_nameProp] = name;
      newObject[g_aliasProp] = alias;
      newObject[g_valueProp] = val;

      //Check if it needs to be wrapped.
      if (createArrayWrapper) {
        return [newObject];
      } else {
        return newObject;
      }
    },
    createIndicatorObject: function (name, alias, val, createArrayWrapper, type) {
      //Create New Object.
      var newObject = {};
      newObject[g_nameProp] = name;
      newObject[g_aliasProp] = alias;
      newObject[g_valueProp] = val;
      newObject[g_typeProp] = type;

      //Check if it needs to be wrapped.
      if (createArrayWrapper) {
        return [newObject];
      } else {
        return newObject;
      }
    },
    array_pluck: function (arr, callback_or_key) {
      var plucked_array = [];
      if (!('length' in arr && typeof arr === 'object')) {
        throw new Error('The first argument to array_pluck must be an array.');
      }
      for (var i in arr) {
        if (typeof callback_or_key === 'function') {
          plucked_array.push(callback_or_key(arr[i]));
        } else {
          plucked_array.push(arr[i][callback_or_key]);
        }
      }
      return plucked_array;
    },
  };
})();

(function (window) {
  'use strict';

  function byVariableState(nvl_array) {
    var _this = this;

    _this.arg = nvl_array;

    _this.sorted_indicators = statCompilerDashboard.getArrSortedIndicators();

    _this.selected_indicator_from_hash = _this.sorted_indicators[parseInt(getQueryVariable('si'))];

    _this.byvariables_from_hash = {};

    getQueryVariable('sbv')
      .slice(0, -1)
      .split(']')
      .forEach(function (q) {
        var parts = q.split('[');
        if (parts.length < 2) return;
        _this.byvariables_from_hash[parts[0]] = parts[1].split(',');
      });

    Object.defineProperty(this, 'unpack_nvl', {
      value: function (nvl_array) {
        var this_nvl_array = nvl_array;

        return this_nvl_array.map(function (v, i) {
          var returnObj = {};
          var item = { all: v.value };

          Object.defineProperty(item, 'current', {
            get: function () {
              if (_this.byvariables_from_hash[item.indicator_id]) {
                return _this.byvariables_from_hash[item.indicator_id].map(function (vv) {
                  return item.all[vv];
                });
              } else if (typeof byVariableState.preferred_values[v.name] !== 'undefined') {
                return [byVariableState.preferred_values[v.name]];
              } else return [v.value[0]];
            },
            set: function (val) {
              delete this.current;

              if (!_.isArray(val)) {
                val = [val];
              }
              this.current = val;
            },
            configurable: true,
            enumerable: true,
          });

          Object.defineProperty(item, 'preferred', {
            get: function () {
              if (typeof byVariableState.preferred_values[v.name] !== 'undefined') {
                return byVariableState.preferred_values[v.name];
              } else return v.value[0];
            },
            set: function (val) {
              delete this.preferred;

              this.preferred = val;
            },
            configurable: true,
            enumerable: true,
          });

          Object.defineProperty(item, 'indicator_id', {
            get: function () {
              var val = v.name;
              delete this.indicator_id;

              this.indicator_id = val;
              return val;
            },
            configurable: true,
            enumerable: true,
          });

          returnObj[v.name] = item;
          return returnObj;
        });
      },
    });

    _this.unpack_nvl(_this.arg).forEach(function (v) {
      byVariableState.items = _.extend(byVariableState.items, v);
    });
  }

  Object.defineProperty(byVariableState, 'items', {
    value: {},
    writable: true,
  });

  Object.defineProperty(byVariableState, 'preferred_values', {
    value: {},
    writable: true,
  });

  Object.defineProperty(byVariableState, 'indicator_id_map', {
    value: {},
    writable: true,
  });

  Object.defineProperty(byVariableState, 'swap_indicator', {
    value: function (str) {
      return (
        _.findKey(byVariableState.indicator_id_map, function (v) {
          return v == str;
        }) || _.get(byVariableState.indicator_id_map, str)
      );
    },
  });

  Object.defineProperty(byVariableState, 'get', {
    value: function (key, fallback) {
      var fallback = typeof fallback !== 'undefined' ? fallback : null;
      // var key = byVariableState.indicator_id_map[key] || key;
      return _.get(byVariableState.items, key, fallback);
    },
  });

  Object.defineProperty(byVariableState, 'all', {
    value: function () {
      return byVariableState.items;
    },
  });

  window.byVariableState = byVariableState;
})(window);
